// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3EyUq","selects":"Documents_selects__2NZ-b"};